import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';

export type GetPatientSummaryContactInformationParams = PatientCommandParams;

export const GetPatientSummaryContactInformation = (
	params: GetPatientSummaryContactInformationParams,
): Command => {
	return {
		operation: 'DajPacientskySumarKontaktneUdaje_v4',
		params,
	};
};
